import React, { Component } from 'react';
import { BreadCumb, DataTables, NavBar, TimeOut } from "../../components";
import config from "../../config";
import moment from "moment";
import { ApiClient } from "../../libs/apiClient";
import { DISPATCH_ID, SERVICE_RESPONSE } from "../../libs/utils/Const";
import { connect } from "react-redux";

let apiClient = ApiClient.getInstance();

const headersDataTable = [ // Nota: Si se modifican estos modificar igual los de DraftView
    { title: "Serie", value: true },//0
    { title: "Num.Doc", value: true },//1
    { title: "Estatus", value: true },//2
    { title: "Cliente", value: true },//3
    { title: "Nombre", value: true },//4
    { title: "De Almacén", value: true },//5
    { title: "Almacén destino", value: true },//6
    { title: "Tipo de Salida del Documento", value: true },//7
    { title: "Centro de Costo (CeCo)", value: true },//8
    { title: "Fecha Cont.", value: true },//9
    { title: "Empl. Ventas", value: true },//10
    { title: "Comentarios", value: true },//11
    { title: "Total", value: true },//12
    { title: "Observacion del Estado", value: true },//13
    { title: "Estado del documento", value: true }//14
];

class TransfersRequestView extends Component {
    constructor(props) {
        super(props)

        this.state = {
            updateData: false,
            headers: headersDataTable,
            data: [],
            _user: JSON.parse(localStorage.getItem(config.localStorageNamed + 'currentUser'))
        }

    }

    async componentDidMount() {
        localStorage.setItem(config.localStorageNamed + 'toogleNavBarItem', "liTrasladoRequest");
        let today = moment(new Date()).format('YYYYMMDD');

        let date = {
            dateInit: today,
            dateFinal: today,
        }
        await this.callDocumentsListService(date);
    }

    callDocumentsListService = async newDate => {

        const { notificationReducer: { showAlert }, enableSpinner } = this.props;
        let user = JSON.parse(localStorage.getItem(config.localStorageNamed + 'currentUser'));
        let defaultWhs = user?.Branch?.ProjectCode ?? "--";
        let data = {
            dateInit: newDate.dateInit,
            dateFinal: newDate.dateFinal,
            table: "OWTQ",
            docNumSearch: newDate.docNumSearch ? newDate.docNumSearch === '' ? '--' : newDate.docNumSearch : '--',
            searchByWhs: defaultWhs ? defaultWhs === '' ? '--' : defaultWhs : '--',
            switch1: newDate.docStatus || '---',
        };

        enableSpinner(true);
        let transfersListResponse = await apiClient.getDocumentsList(data);
        enableSpinner(false);

        if (transfersListResponse.status === SERVICE_RESPONSE.SUCCESS) {


            /*let dataSerie = {
                docType: "1250000001",
                docSubType: "--"
            };

            enableSpinner(true);
            let seriesResponse = await apiClient.getSeries(dataSerie);
            enableSpinner(false);

            let user = JSON.parse(localStorage.getItem(config.localStorageNamed + 'currentUser'));

            let ValidateSeries = user.U_FMB_ValidateSeriesOWTQ ? user.U_FMB_ValidateSeriesOWTQ : "";

            if (!user || ValidateSeries == "") {
                showAlert({
                    type: 'warning',
                    timeOut: 5000,
                    message: "Ocurrio un error en obtener las series permitidas para el usuario, intente reiniciar la sesión o contactar con su administrador"
                });

                this.setState({
                    data: [],
                });
                return;
            }

            let seriesUsers = ValidateSeries.split("|");


            let newArraySeries = [];

            seriesUsers.map(serieUser => {
                seriesResponse.data.map(serieResponse => {
                    if (serieResponse.Series == serieUser) {
                        newArraySeries.push(serieResponse);
                    }
                })
            })

            if (newArraySeries.length === 0) {
                showAlert({
                    type: 'warning',
                    timeOut: 5000,
                    message: "El usuario no tiene serie permitida de escritura y lectura"
                });
                return;
            }


            let newDocumentsfilterSeries = [];

            transfersListResponse.data.map(document => {
                newArraySeries.map(serie => {
                    if(document.SeriesCode == serie.Series){
                        newDocumentsfilterSeries.push(document);
                    }
                })
            });*/


            let newDocumentsFilterSeries = transfersListResponse.data;
            this.setState({
                data: newDocumentsFilterSeries,
            });
            return;
        }

        // showAlert({type: 'error', message: transfersListResponse.message});

    };


    searchDocuments = async date => {
        //console.log(date);
        await this.callDocumentsListService(date);
    };

    render() {
        const { headers, data, updateData, _user } = this.state;

        return (
            <div className="content">
                <NavBar props={this.props} _user={_user} />
                <BreadCumb subitem1={'SOLICITUD DE TRASLADO'} url1={'#'} />
                <TimeOut />
                <div style={{ marginLeft: "4rem", marginBottom: "12rem" }}>

                    <h2 className="md-display-1">
                        <label id="linkOrdProv" className="text-muted">
                            &nbsp;SOLICITUD DE TRASLADO
                        </label>
                    </h2>
                    <DataTables headers={headers} view={"transfersRequest"} data={data} search={this.searchDocuments} />
                </div>
            </div>
        );
    }
}

const mapStateToProps = store => {
    return { notificationReducer: store.NotificationReducer };
};

const mapDispatchToProps = dispatch => {
    return {
        enableSpinner: value => dispatch({ type: DISPATCH_ID.CONFIG_SET_SPINNER, value })
    };
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(TransfersRequestView);